import {AppDispatch} from "@/redux/store";
import {setCurrentUser} from "@/redux/user.reducer";

export const forceLogout = (dispatch: AppDispatch) => {
    dispatch(setCurrentUser(null));
    const authChannel = new BroadcastChannel("auth");
    authChannel.postMessage("logout");
};
